import { useQuery } from 'react-query';
import backend from '../backend';

// tipagem do retorno do request
interface IResponseData {
  valor_custo: number;
  valor_comissao: number;
  valor_venda: number;
}

// tipagem do que o hook retorna
export type IUsuariosReponse = IResponseData;

async function getValoresCertificadoUsuario(
  id: number,
): Promise<IUsuariosReponse> {
  const response = await backend.get<IResponseData>(
    `/usuarios/${id}/valores-certificado`,
  );
  return response.data;
}

export function useValoresCertificadoUsuario(id: number) {
  return useQuery(
    ['valores-certificado-usuario', id],
    () => getValoresCertificadoUsuario(id),
    {
      staleTime: 1000 * 60 * 0,
      cacheTime: 1000 * 60 * 0,
      // refetchOnWindowFocus: true,
    },
  );
}
